import { usersSlice } from "./usersSlice";
import * as defaultActions from "../../../../../redux/_common";
import { format } from "date-fns";

const { actions } = usersSlice;
export const moduleUrl = "/api/usersmanagement/users";

export const setValidationErrors = actions.setValidationErrors;

export const getUsers = (params: {}) => defaultActions.getItems(moduleUrl, actions, params);

export const saveUser = (user: {}, id: string | null) => defaultActions.saveItem(moduleUrl, actions, user, id, (data:any) => {

    const mapTimeToHHmm = (value: Date | string | null | undefined) => {
        if (!value) return value;

        const dateValue = new Date(value);
        return isNaN(dateValue.getTime()) ? value : format(dateValue, "HH:mm:ss");
    };

    return {
        ...data,
        workStartTime: mapTimeToHHmm(data.workStartTime),
        workEndTime: mapTimeToHHmm(data.workEndTime),
        territories: data.territories ? data.territories.map((id:string) => ({id})) : data.territories,
    };
});

export const getUser = (id: string) => defaultActions.getItem(`${moduleUrl}/${id}`, actions);

export const deleteUser = (id: string) => defaultActions.deleteItem(`${moduleUrl}/${id}`, actions);

export const getDropDownItems = (params:any) =>  defaultActions.getDropDownItems(`${moduleUrl}/select`, actions, params)

export const getUsersByTerritoryDropdownItems = (params:any) => defaultActions.getDropDownItems(`${moduleUrl}/byTerritory/select`, actions, params)

export const clearAll = () => defaultActions.clearAll(actions);
export const clearUser = () => defaultActions.clearItem(actions);
export const clearErrors = () => defaultActions.clearErrors(actions);
